module.exports = __webpack_public_path__ + "static/fipcbluewhalemain-83bf1ae8d9f0bcde6c8157bace36a7b6.jpeg";